export default "__VITE_ASSET__$hmmfdzs__"